// extracted by mini-css-extract-plugin
export default {"container":"lo5eF8","messageElement":"klAvSU","noWrap":"DbGkzz","logo":"Z7JH7U","ctaLink":"F76jgR","hidden":"I4ozwN"};